export default __webpack_public_path__ + "static/media/appleappstore.c192f2fd.svg";